import apiManagerUser from "api/manager-users";
import { DIALOG_ID } from "components/Dialog/constant";
import { PATH_ROOT } from "constants/api";
import { CALENDAR_VIEW, CONFIG_CODE, DEFAULT_ERROR, ERROR_CODE_SERVER, ID_LOADING_BUTTON, RECORING_ERR_CODE, TYPE_GET_ERR_CODE, TYPE_UPDATE_LOADING_BUTTON } from "constants/common";
import { FUNCTIONS } from "constants/roles";
import { LIST_DOMAIN_AUTO_LOGLIN, LIST_DOMAIN_EXIST } from "constants/sso";
import i18next from "i18next";
import { decode } from "js-base64";
import { setCustomMessage } from "pages/manager-whiteboard/whiteboardListSlice";
import parse from "parse-duration";
import { useEffect, useState } from "react";
import { appNavigate } from "shared/navigate/navigationService";
import { ToastContent as ToastCard, toastService } from "shared/ui/toast";
import { updateLoadingButton } from "store/commonSlice";
import { setClose, setCloseCC, setOpen, setOpenCC } from "store/dialogSlice";
import store from "store/store";
import { sessionAuthenticated } from 'store/sessionSlice';
import {
    selectCurrentUserFunctions,
    selectCurrentUserFunctionsLoaded,
    selectSystemConfigs,
} from 'store/selectors';
import { checkFunctionHaveCode } from "store/user/functions";
import { updateFunctions } from "store/user/userSlice";
import { getAccessToken, getRefreshToken } from "./cookies";
import { FUNCTION_SCOPE_EMPTY, getFunctionScope, getFunctionScopeUiState } from "./functions/functionScope";
import { USER_PROPERTIES } from "constants/user";
import { IconScheduleNoFill, IconScheduleToday } from "pages/manager-meeting/components/IconManagerMeeting";
import { replaceConfirmRefreshTimer } from 'services/sessionTimerService';

/**
 * Lấy giá trị config
 * @param name 
 * @param configs 
 * @returns value
 */
export function getConfigValue(name) {
    const systemConfigs = selectSystemConfigs(store.getState())
    if (!systemConfigs || !name || !systemConfigs?.length) return ''
    const _config = systemConfigs.find(c => c?.name === name || c?.code === name)
    if (_config) return _config.value

    return ''
}

/**
 * Set timeout show dialog confirm section
 * @returns 
 */
export function setTimeoutConfirmRefreshToken() {
    const configTimeout = parse(getConfigValue(CONFIG_CODE.TIMEOUT_CONFIRM_REFRESH_TOKEN), 's') * 1000
    if (!configTimeout) return
    replaceConfirmRefreshTimer(() => {
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM_REFRESH_TOKEN
        })
    }, configTimeout)
}

/**
 * Lấy danh sách lỗi từ mã lỗi api trả về
 * @param {*} code: mã code api trả về
 * @param {*} type: phân hệ gọi api
 * @returns danh sách lỗi
 */
export function getErrorByCode({ code, type }) {
    let errors = [];
    let listErrorsCode = [];

    if (ERROR_CODE_SERVER.includes(code)) {
        errors.push(DEFAULT_ERROR.find((err) => err.code === code)?.name || 'errCode.errorUnknow');
    } else {
        switch (type) {
            case TYPE_GET_ERR_CODE.RECORDING:
                listErrorsCode = RECORING_ERR_CODE;
                break;
            default:
                break;
        }
    }

    listErrorsCode.forEach((err) => {
        const isErr = code & err.code;
        if (isErr) errors.push(err.name);
    });

    return errors;
}

export function toastErrorFetchAPI({ result, typeErrCode, tcm, toastError, titleToastError }) {
    let errs = getErrorByCode({ code: result.code, type: typeErrCode });
    errs = errs.map((e) => tcm(e));
    toastError(titleToastError || tcm('toast.errorServer'), errs.join('. '));
}

/**
 * return enviroment variable in env-config.js or process.env
 *
 * @param  name
 */

export function env(name) {
    return (window._env_ ? window._env_[name] : null) || process.env[name]
}

export function isDisabledLockOrUnLock(data, selected, isLock) {
    if (!data || !selected) return false
    if (isLock) {
        return data.filter(
            (wb) =>
                wb.is_locked &&
                selected.includes(wb.white_board_id),
        ).length === 0
    }
    return data.filter(
        (wb) =>
            !wb.is_locked &&
            selected.includes(wb.white_board_id),
    ).length === 0
}

export function isDisabledLockOrUnLockSub(data, selected, isLock) {
    if (!data || !selected) return false
    if (isLock) {
        return data.filter(
            (sub) =>
                sub.is_locked &&
                selected.includes(sub.id),
        ).length === 0
    }
    return data.filter(
        (sub) =>
            !sub.is_locked &&
            selected.includes(sub.id),
    ).length === 0
}

export function isDisabledRestoreOrDeleteForeverOrDelete(data, selected) {
    if (selected?.length > 0) return false
    return true
}

export function replaceSpaceAndTrim(values) {
    if (!values) return ''
    return values.replace(/ + /g, " ").trim()
}

/**
 * Hiển thị danh sách user trong bảng user sip
 * @param {*} users 
 * @returns 
 */
export function renderUsersSip(users) {
    if (!users.length) return ''
    const _usernames = users.map(user => user.username)
    return _usernames.join(', ')
}

/**
 * Hiển thị giới tính trong table
 * @param {*} gender 
 * @returns 
 */
export function renderGender(gender) {
    if (!gender) return ''
    return i18next.t('tablev1.gender.' + gender)
}

export function getIndexCellTable(currentPage, limit, index) {
    if (currentPage < 0) return 0 * limit + index + 1
    return currentPage * limit + index + 1
}

export function getIndexCellTableSubs(currentPage, limit, index) {
    if (currentPage < 2) return 0 * limit + index + 1
    return (currentPage - 1) * limit + index + 1
}

export function getTitleBtnCalendar(view) {
    return {
        btn: view === CALENDAR_VIEW.TIME_GRID_DAY ? 'manageMeeting:calendar.today' : 'manageMeeting:calendar.currentWeek',
        tooltip: view === CALENDAR_VIEW.TIME_GRID_DAY ? 'manageMeeting:calendar.backToDay' : 'manageMeeting:calendar.backToCurrentWeek',
        next: view === CALENDAR_VIEW.TIME_GRID_DAY ? 'manageMeeting:calendar.nextday' : 'manageMeeting:calendar.nextweek',
        prev: view === CALENDAR_VIEW.TIME_GRID_DAY ? 'manageMeeting:calendar.prevday' : 'manageMeeting:calendar.prevweek',
    }
}

export function RenderIconCurrentDay({ view, disabled = false }) {
    if (view === CALENDAR_VIEW.TIME_GRID_DAY) {
        return <IconScheduleToday />
    }
    return <IconScheduleNoFill disabled={disabled} />
}

export function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

/**
 * anhnt653 Hiển thị loading
 */
export function setIsLoading() {
    // store.dispatch(setIsloading())
}

/**
 * anhnt653 Ẩn thị loading
 */
export function setIsLoaded() {
    // store.dispatch(setIsloaded())
}

/**
 * Kiểm tra người dùng ở trang main
 * @returns 
 */
export async function loaderCheckUser() {
    const functionsLoaded = selectCurrentUserFunctionsLoaded(store.getState())

    if (!functionsLoaded && getAccessToken()) {
        try {
            const functionResponse = await apiManagerUser.getUserFunctions();
            if (functionResponse?.status === "success") {
                store.dispatch(updateFunctions(functionResponse?.data))
            }
        } catch (error) {
            console.error('[Error] getUserFunctions: ', error)
        }
    }

    let domainArray = env('REACT_APP_DOMAIN_ARRAY') || LIST_DOMAIN_EXIST;

    if (window.location.href.includes('/login') && domainArray.some(p => window.location.search.includes(p))) {
        return window.location.href = `/auth/login${window.location.search}`
    }

    return null
}

/**
 * Kiểm tra người dùng ở trang auth
 * @returns 
 */
export async function loaderCheckUserAuth() {
    if (getRefreshToken()) {
        try {
            const res = await apiManagerUser.getUserByToken()
            if (res.status === 200) {
                store.dispatch(sessionAuthenticated())
            }
        } catch (err) {
            console.log('err', err)
        }
    }
    return null
}

/**
 * Sao chép vào bộ nhớ
 * @param {*} e 
 */
export function copyToClipboard(e) {
    navigator.clipboard.writeText(e);
    toastSuccess(i18next.t('toast.Success'), i18next.t('toast.copied'))
};

/**
 * Thông báo thành công
 * @param {*} title 
 * @param {*} text 
 * @param {*} options 
 * 
 */



export function toastSuccess(title, text, options) {
    toastService.success(title, text, options);
}

/**
 * Thông báo nguy hiểm
 * @param {*} title 
 * @param {*} text 
 * @param {*} options 
 */
export function toastWarning(title, text, options, onClick) {
    toastService.warning(title, text, { ...options, onClick });
}

/**
 * Thông báo thông tin
 * @param {*} title 
 * @param {*} text 
 * @param {*} options 
 */


export function toastInfo(title, text, options) {
    toastService.info(title, text, options);
}

export function toastInfoInviteUsingStorage(title, text, options, navigate) {
    toastService.info(title, text, {
        ...options,
        onClick: () => { navigate(`${PATH_ROOT}/manager-storage`); }
    });
}

export function toastInfoInvite(title, text, options, dispatch, navigate) {
    toastService.info(title, text, {
        ...options,
        onClick: () => { navigate(`${PATH_ROOT}/profile-user`); }
    });
}

/**
 * Thông báo lỗi
 * @param {*} title 
 * @param {*} text 
 * @param {*} options 
 */
export function toastError(title, text, options) {
    toastService.error(title, text, options);
}

export function setOpenDialogCC({ id, props = {} }) {
    store.dispatch(setOpenCC({ id, props }))
}

export function setCloseDialogCC() {
    store.dispatch(setCustomMessage(''))
    store.dispatch(setCloseCC())
}

export function removeLoadingButtonDialogConfirm() {
    store.dispatch(updateLoadingButton({ type: TYPE_UPDATE_LOADING_BUTTON.REMOVE, id: ID_LOADING_BUTTON.CONFIRM_DIALOG }))
}

// This function converts the string to lowercase, then perform the conversion
export function toLowerCaseNonAccentVietnamese(str) {
    if (!str) return ''
    str = str.toLowerCase();
    //     We can also use this instead of from line 11 to line 17
    //     str = str.replace(/\u00E0|\u00E1|\u1EA1|\u1EA3|\u00E3|\u00E2|\u1EA7|\u1EA5|\u1EAD|\u1EA9|\u1EAB|\u0103|\u1EB1|\u1EAF|\u1EB7|\u1EB3|\u1EB5/g, "a");
    //     str = str.replace(/\u00E8|\u00E9|\u1EB9|\u1EBB|\u1EBD|\u00EA|\u1EC1|\u1EBF|\u1EC7|\u1EC3|\u1EC5/g, "e");
    //     str = str.replace(/\u00EC|\u00ED|\u1ECB|\u1EC9|\u0129/g, "i");
    //     str = str.replace(/\u00F2|\u00F3|\u1ECD|\u1ECF|\u00F5|\u00F4|\u1ED3|\u1ED1|\u1ED9|\u1ED5|\u1ED7|\u01A1|\u1EDD|\u1EDB|\u1EE3|\u1EDF|\u1EE1/g, "o");
    //     str = str.replace(/\u00F9|\u00FA|\u1EE5|\u1EE7|\u0169|\u01B0|\u1EEB|\u1EE9|\u1EF1|\u1EED|\u1EEF/g, "u");
    //     str = str.replace(/\u1EF3|\u00FD|\u1EF5|\u1EF7|\u1EF9/g, "y");
    //     str = str.replace(/\u0111/g, "d");
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    //eslint-disable-next-line
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, "");
    str = str.replace(/ + /g, "");
    str = str.trim();
    str = str.replace(/\s/g, '');
    return str;
}

function setCloseDialog() {
    store.dispatch(setClose());
}

function setOpenDialog(id) {
    store.dispatch(setOpen(id))
}

/**
 * anhnt653 20230913
 * Lấy domain để set cookies
 * @returns domain
 */
export function domainCookies() {
    const domainSplit = window.location.hostname.split('.')
    return window.location.href.includes('localhost') ? '' : `${domainSplit[domainSplit.length - 2]}.${domainSplit[domainSplit.length - 1]}`
}


export function generateCodeVerifier() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

// Function to compute the SHA-256 hash
export async function sha256(plainText) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plainText);
    return crypto.subtle.digest('SHA-256', data);
}

// Function to base64-url encode the hash
export function base64UrlEncode(arrayBuffer) {
    const byteArray = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < byteArray.byteLength; i++) {
        binary += String.fromCharCode(byteArray[i]);
    }
    return btoa(binary)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

function validateDomain(domain) {
    if (!domain) return '';

    try {
        const validDomainList = env('REACT_APP_DOMAIN_ARRAY') || LIST_DOMAIN_EXIST
        const targetUrl = new URL(domain);

        const isValid = validDomainList.some((validDomain) => {
            const validUrl = new URL(validDomain);

            return (
                targetUrl.origin === validUrl.origin &&
                (
                    validUrl.pathname === '/' ||
                    targetUrl.pathname === validUrl.pathname ||
                    targetUrl.pathname.startsWith(`${validUrl.pathname}/`)
                )
            );
        });

        return isValid ? domain : '';
    } catch {
        return '';
    }
}

function parseMCURoomId(roomId) {
    if (!roomId) return null;

    const safeRoomId = Number(roomId);

    if (!Number.isInteger(safeRoomId) || safeRoomId <= 0) {
        return null;
    }

    return safeRoomId;
}


function getAutoLogin(autoLogin) {
    if (autoLogin && LIST_DOMAIN_AUTO_LOGLIN.includes(autoLogin)) return autoLogin
    return ''
}

function canDoAction(code) {
    const isSystemAdmin = getUserProperty(USER_PROPERTIES.SYSTEM_ADMIN)
    if (isSystemAdmin) return true

    if (!code) return false

    const functions = selectCurrentUserFunctions(store.getState());

    if (!Array.isArray(functions)) return false;

    if (!FUNCTIONS[code?.code]) return false;

    return checkFunctionHaveCode(functions, code);
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const getUserInfoByToken = () => {
    const accessToken = getAccessToken()

    if (!accessToken) return undefined

    const tokenPayload = accessToken.split('.')[1]
    if (!tokenPayload) return undefined

    try {
        return JSON.parse(decode(tokenPayload))?.context?.user
    } catch {
        return undefined
    }
}

export const getUserProperty = (property) => {
    const userInfo = getUserInfoByToken()

    if (userInfo) return userInfo?.[property]
    return undefined
}

export const useFunctionPermission = (functionCode, options = {}) => {
    const { redirectOnDenied = false } = options;

    const [state, setState] = useState(() => ({
        loading: true,
        ...getFunctionScopeUiState(FUNCTION_SCOPE_EMPTY),
    }));

    useEffect(() => {
        let cancelled = false;

        const setEmptyPermission = (loading = false) => {
            setState({
                loading,
                ...getFunctionScopeUiState(FUNCTION_SCOPE_EMPTY),
            });
        };

        const fetchPermission = async () => {
            if (!functionCode) {
                setEmptyPermission(false);
                return;
            }

            try {
                setState((prev) => ({
                    ...prev,
                    loading: true,
                }));

                const scopeResponse = await getFunctionScope(functionCode);

                if (cancelled) return;

                const scope = getFunctionScopeUiState(scopeResponse);

                setState({
                    loading: false,
                    ...scope,
                });

                if (!scope.isAllowed && redirectOnDenied) {
                    appNavigate('/errors/forbidden', { replace: true });
                }
            } catch (error) {
                if (cancelled) return;

                setEmptyPermission(false);

                if (
                    redirectOnDenied &&
                    [401, 403].includes(error?.response?.status)
                ) {
                    appNavigate('/errors/forbidden', { replace: true });
                }
            }
        };

        fetchPermission();

        return () => {
            cancelled = true;
        };
    }, [functionCode, redirectOnDenied]);

    return state;
};

export { canDoAction, getAutoLogin, parseMCURoomId, setCloseDialog, setOpenDialog, sleep, ToastCard, validateDomain };
